import { createContext } from "react";
const PaymentProvider = createContext();
export default PaymentProvider;
